/* Swissöra premium — FOMO social-proof pills (V2 brief #8).
   Bottom-left, dismissible recent-purchase notifications + occasional
   "X personnes regardent ce produit". Large realistic FR/EU name+city pool,
   randomized message + timing (25-60s, not spammy), auto-dismiss, FR/EN aware.
   No emoji — small inline SVG check / pulsing dot. */
(function () {
  'use strict';

  function lang() { return document.documentElement.getAttribute('data-lang') === 'en' ? 'en' : 'fr'; }
  var L = lang();

  var NAMES = [
    'Marie', 'Camille', 'Sophie', 'Léa', 'Emma', 'Chloé', 'Manon', 'Sarah', 'Julie', 'Laura',
    'Inès', 'Clara', 'Anaïs', 'Pauline', 'Océane', 'Mathilde', 'Charlotte', 'Lucie', 'Élise', 'Margaux',
    'Noémie', 'Audrey', 'Céline', 'Amandine', 'Justine', 'Mélanie', 'Aurélie', 'Élodie', 'Fanny', 'Coralie',
    'Giulia', 'Sofia', 'Elena', 'Anna', 'Lena', 'Marta', 'Núria', 'Carlota', 'Hannah', 'Sara'
  ];
  var CITIES = {
    fr: ['Lyon', 'Paris', 'Marseille', 'Bordeaux', 'Lille', 'Toulouse', 'Nantes', 'Strasbourg', 'Nice', 'Rennes',
         'Montpellier', 'Grenoble', 'Annecy', 'Aix-en-Provence', 'Genève', 'Lausanne', 'Bruxelles', 'Luxembourg', 'Lyon', 'Dijon'],
    en: ['Lyon', 'Paris', 'Marseille', 'Bordeaux', 'Lille', 'Toulouse', 'Nantes', 'Strasbourg', 'Nice', 'Rennes',
         'Montpellier', 'Grenoble', 'Annecy', 'Aix-en-Provence', 'Geneva', 'Lausanne', 'Brussels', 'Luxembourg', 'Milan', 'Madrid']
  };
  /* Uniquement des offres réellement achetables : SwissLash 1 / 2 / 3 mois.
     SwissBrow & SwissMascara sont "bientôt disponibles" — jamais dans le social proof. */
  var PRODUCTS = {
    fr: ['SwissLash', 'le sérum SwissLash', 'la Cure SwissLash 2 mois', 'la Cure SwissLash 3 mois', 'SwissLash — Sérum cils'],
    en: ['SwissLash', 'the SwissLash serum', 'the SwissLash 2-month course', 'the SwissLash 3-month course', 'SwissLash — Lash serum']
  };

  /* small SVG marks (no emoji) */
  var CHECK = '<svg class="fomo__check" viewBox="0 0 24 24" width="16" height="16" aria-hidden="true">' +
    '<circle cx="12" cy="12" r="11" fill="#0bb57b"/><path d="M7 12.5l3 3 7-7" fill="none" stroke="#fff" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var DOT = '<span class="fomo__dot" aria-hidden="true"></span>';

  function rand(arr) { return arr[Math.floor(Math.random() * arr.length)]; }
  function randInt(min, max) { return Math.floor(Math.random() * (max - min + 1)) + min; }

  function purchaseMsg() {
    var name = rand(NAMES);
    var city = rand(CITIES[L]);
    var product = rand(PRODUCTS[L]);
    var mins = randInt(2, 47);
    if (L === 'en') {
      return { mark: CHECK, title: name + ' from ' + city, body: 'just ordered ' + product,
               meta: mins + ' min ago' };
    }
    return { mark: CHECK, title: name + ' de ' + city, body: 'vient d\'acheter ' + product,
             meta: 'il y a ' + mins + ' min' };
  }

  function watchingMsg() {
    var n = randInt(9, 34);
    if (L === 'en') {
      return { mark: DOT, title: n + ' people', body: 'are viewing this product right now', meta: 'Live' };
    }
    return { mark: DOT, title: n + ' personnes', body: 'regardent ce produit en ce moment', meta: 'En direct' };
  }

  /* mount container (bottom-left) */
  var mount = document.createElement('div');
  mount.className = 'fomo-stack';
  mount.setAttribute('aria-live', 'polite');
  document.body.appendChild(mount);

  var dismissed = sessionStorage.getItem('swissora_fomo_off') === '1';
  var shownCount = 0;
  var maxShown = 14; /* cap so it never gets spammy across a session */

  function show() {
    if (dismissed || shownCount >= maxShown) return;
    /* ~1 in 4 is a "watching" pill, rest are purchases */
    var m = (Math.random() < 0.25) ? watchingMsg() : purchaseMsg();
    var pill = document.createElement('div');
    pill.className = 'fomo-pill';
    pill.innerHTML =
      '<span class="fomo-pill__mark">' + m.mark + '</span>' +
      '<span class="fomo-pill__text"><strong>' + m.title + '</strong> ' + m.body +
        '<span class="fomo-pill__meta">' + m.meta + '</span></span>' +
      '<button class="fomo-pill__close" type="button" aria-label="Fermer">&times;</button>';
    mount.appendChild(pill);
    shownCount++;
    requestAnimationFrame(function () { pill.classList.add('show'); });

    var hideT = setTimeout(dismiss, randInt(5500, 7000)); /* auto-dismiss */
    function dismiss() {
      clearTimeout(hideT);
      pill.classList.remove('show');
      setTimeout(function () { if (pill.parentNode) pill.parentNode.removeChild(pill); }, 400);
    }
    pill.querySelector('.fomo-pill__close').addEventListener('click', function () {
      /* one explicit close silences the stream for the session */
      dismissed = true;
      sessionStorage.setItem('swissora_fomo_off', '1');
      dismiss();
    });
    if (window.posthog) try { posthog.capture('fomo_view'); } catch (x) {}
  }

  function loop() {
    if (dismissed) return;
    show();
    setTimeout(loop, randInt(25000, 60000)); /* 25–60s between pills */
  }

  /* Pop-up DÉSACTIVÉ (Nour) — la preuve sociale est désormais fondue dans la petite
     pilule "live" en bas à gauche (voir personalize.js), beaucoup moins intrusif.
     Pour réactiver le pop-up : décommenter la ligne ci-dessous. */
  // if (!dismissed) setTimeout(loop, randInt(9000, 14000));
})();
